/**
 * Common function that builders should use retrieve linked questions from a question group object
 *
 * @param {Object} questionGroup: Question group object which holds all the questions for a given view
 * @param {Array} linkedQuestionKeys: array of appkeys for questions we want to return from the question group
 * @returns {*}
 */
const builderGetLinkedQuestions = (questionGroup, linkedQuestionKeys = []) => {
  return linkedQuestionKeys.map(appkey => {
    return questionGroup.questions.find(q => q.appkey === appkey);
  }).filter(q => q);
};

export {
  builderGetLinkedQuestions as default,
};
